// @flow

import React from "react";
import styled from "styled-components";

import { Flex } from "@src/common";

const UnsupportedImage = require("./../../../public/assets/images/unsupportedBrowserBackground.png");
const UnsupportedOnMobileWrapper = styled(Flex)`
  min-height: 100vh;
`;

const UnsupportedOnMobile = styled(Flex)`
  background: url(${UnsupportedImage}) no-repeat center;
  background-size: contain;
`;

export default props => (
  <UnsupportedOnMobileWrapper flexDirection="column" padding={4} paddingT={3}>
    <UnsupportedOnMobile />
  </UnsupportedOnMobileWrapper>
);



// WEBPACK FOOTER //
// ./src/components/Unsupported/mobile.jsx